import { Link } from 'react-router-dom';
import { getTrendingComics } from '@/mocks/comics';

export default function PopularSection() {
  const trending = getTrendingComics();

  return (
    <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            热门排行
          </h2>
          <p className="text-sm text-foreground-500 mt-1">大家都在看的高人气韩漫</p>
        </div>
        <Link
          to="/category/all"
          className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          完整榜单
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="flex flex-col gap-2">
        {trending.map((comic, idx) => (
          <Link
            key={comic.id}
            to={`/article/${comic.id}`}
            className="flex items-center gap-4 p-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 group cursor-pointer"
          >
            <div
              className={`w-8 h-8 flex items-center justify-center rounded-full font-bold text-sm shrink-0 ${
                idx === 0
                  ? 'bg-accent-500 text-background-50'
                  : idx === 1
                  ? 'bg-secondary-500 text-background-50'
                  : idx === 2
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-500'
              }`}
            >
              {idx + 1}
            </div>

            <div className="w-12 h-16 rounded overflow-hidden shrink-0">
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>

            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
              <div className="flex items-center gap-3 mt-1">
                <span className="text-[10px] px-1.5 py-0.5 bg-secondary-100 text-secondary-700 rounded">
                  {comic.category === 'romance' ? '恋爱' : comic.category === 'fantasy' ? '奇幻' : comic.category === 'action' ? '动作' : comic.category === 'thriller' ? '悬疑' : comic.category}
                </span>
                <span className="text-xs text-foreground-400">{comic.chapters}话</span>
                <span className="text-xs text-foreground-400">{comic.status}</span>
              </div>
            </div>

            <div className="flex items-center gap-1 text-secondary-500 shrink-0">
              <i className="ri-star-fill text-sm"></i>
              <span className="text-sm font-semibold text-foreground-700">{comic.rating}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}